import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Panel, Row } from 'react-bootstrap';

import GlyphiconButton from './GlyphiconButton';
import AttributeButton from './AttributeButton';

require.ensure([], () => {  
    require('./PMO.less');
});

class AttributeListWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            attributes: this.props.attributes
        };
    }

    // LIFECYCLE METHODS


    componentWillReceiveProps = (nextProps) => {
        this.setState({
            attributes: this.props.attributes
        });
    }

    // EVENT HANDLERS

    handleAddClick = () => {
        this.props.handleNewAttribute();
    }

    handleButtonClick = (id) => {
        this.props.handleSelectAttribute(this.state.attributes[id]);
    }

    // RENDER METHOD

    render = () => {
        let header = <h3 className="text-center"> Attributes </h3>;
        return (
            <Panel header={header}>
                {
                    this.state.attributes.map((attribute, key) => {
                        return <AttributeButton
                                    text={attribute.name}
                                    key={key}
                                    id={key}
                                    handleClick={this.handleButtonClick}
                                    />;
                    })
                }
                <br/>
                <Row>
                    <GlyphiconButton classNames={["add-button"]} name="plus" handleClick={this.handleAddClick}/>
                </Row>
            </Panel>
        );
    }
}

AttributeListWidget.propTypes = {
    attributes: PropTypes.object,
    handleClick: PropTypes.func,
    handleSelectAttribute: PropTypes.func,
    handleNewAttribute: PropTypes.func
};

export default connect()(AttributeListWidget);


/** WEBPACK FOOTER **
 ** ./src/app/components/AttributeListWidget.js
 **/